import { render } from "./CardFifteen.vue?vue&type=template&id=736fa1f8"
import script from "./CardFifteen.vue?vue&type=script&lang=js"
export * from "./CardFifteen.vue?vue&type=script&lang=js"

import "./CardFifteen.vue?vue&type=style&index=0&id=736fa1f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__